import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DjangoPage} from './django-paginator';

export interface Artist {
  company: number;
  facebook_page: string;
  name: string;
  profile_photo: string;
  id: number;
}

@Injectable({providedIn: 'root'})
export class ArtistService {
  apiEndpoint = '/rest-api/v1/';

  constructor(private http: HttpClient) {}

  getCompanyArtists = company => this.http.get<DjangoPage<Artist>>(this.apiEndpoint + `companies/${company}/artists`);

  getCompanyArtistsV3 = (company, search?) =>
    this.http.get<DjangoPage<Artist>>(`/rest-api/v3/companies/${company}/artists`, {params: search});

  getArtists = (search?) => this.http.get(this.apiEndpoint + `artists/search?q=${search}`);

  getLineupArtists = eventId => this.http.get<any>(this.apiEndpoint + `events/${eventId}/timetable/get_lineup_artists`);

  getArtistById = artistId => this.http.get<DjangoPage<Artist>>(this.apiEndpoint + `/artists/${artistId}`);

  getDetails = (company, artist) => this.http.get(this.apiEndpoint + `companies/${company}/venues/${artist}`);

  artistsSearch = params => this.http.get<any>(`/rest-api/v1/artists/search`, {params});

  artistsLineupSearch = (companyId, params) => this.http.get<any>(`/rest-api/v2/${companyId}/artists`, {params});

  // Admin endpoints are session-authenticated like everything else in the panel; no token header.
  createSimpleArtistProfile = body =>
    this.http.post(`/rest-api/admin-panel/api/v1/admin/artists/create_simple_profile`, body);
}
